import { graphql } from "gql";

const INTERNAL_ADMIN_CREATE_EMAIL_USER_MUTATION = graphql(`
  mutation InternalAdminCreateEmailUser(
    $organizationId: ID!
    $input: UserInput!
  ) {
    internalAdminCreateEmailUser(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminUser
    }
  }
`);

export default INTERNAL_ADMIN_CREATE_EMAIL_USER_MUTATION;
